"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureModelIsObject = ensureModelIsObject;

function ensureModelIsObject(model) {
  if (typeof model === 'object') {
    return model;
  }

  if (isNumeric(model)) {
    model = {
      id: model
    };
  } else {
    model = {
      path: model
    };
  }

  return model;
}

function isNumeric(str) {
  if (typeof str === 'number') {
    return true; // numbers are numeric
  }

  if (typeof str !== 'string') {
    return false; // other types cannot be parsed
  }

  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseInt` alone does not do this)...
  !isNaN(parseInt(str, 10)); // ...and ensure strings of whitespace fail
}